import { SingleSkeletonLoader } from '../../../components/SingleSkeletonLoader';
import { SubtextDisplay } from '../../../components/merch-card/subtext-display/SubtextDisplay';
import { useIsSeatsUser } from '../../../hooks/user/useUserInfo';
import { isValidProductLevel, isValidQuantityName, isValidSkuCategoryName } from '../../../utils/typeguards';
import { useSubtextDisplayProductDetails } from './useSubtextDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
export const SubtextDisplayContainer = ({
  productApiName
}) => {
  // Portal details
  const isSeatsUser = useIsSeatsUser();

  // Product details
  const {
    productLevel,
    skuCategoryName,
    additionalUnitSkuId,
    quantityName,
    includedWithParentProduct,
    loading
  } = useSubtextDisplayProductDetails({
    productApiName
  });
  if (loading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 17
    });
  }
  if (!isValidProductLevel(productLevel) || !isValidSkuCategoryName(skuCategoryName) || !isValidQuantityName(quantityName)) {
    return null;
  }
  return /*#__PURE__*/_jsx(SubtextDisplay, {
    quantityName: quantityName,
    productLevel: productLevel,
    isSeatsUser: isSeatsUser,
    skuCategoryName: skuCategoryName,
    additionalUnitSkuId: additionalUnitSkuId,
    includedWithParentProduct: includedWithParentProduct,
    queryParamTerm: 'annual'
  });
};